import colors from "../colors.js";

export default colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");



//////////////////
// WEBPACK FOOTER
// ./~/d3-scale-chromatic/src/categorical/category10.js
// module id = 1501
// module chunks = 0